document.addEventListener('DOMContentLoaded', (event) => {
const radioButtons = document.querySelectorAll('.pf-option-swatches input[type="radio"]');
const selectElement = document.querySelector('.single-option-list-type.single-option-selector__radio');
const handleRadioClick = (event) => {
const selectedValue = event.target.value;
selectElement.value = selectedValue;
const changeEvent = new Event('change', { bubbles: true });
selectElement.dispatchEvent(changeEvent);
setTimeout(function(){
variant_change();
},200);
};

radioButtons.forEach((radioButton) => {
radioButton.addEventListener('click', handleRadioClick);
});

function variant_change(){
var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
var variant_id = document.querySelector("[name='id']").value;
var variant_price = document.querySelector(".variant-sellings[data-id='"+variant_id+"']").getAttribute("data-price");
document.querySelector(".one_time_pricing .price-onetime").innerHTML=symbol + variant_price;
document.querySelector(".sell_plan_cs").innerHTML = document.querySelector(".variant-sellings[data-id='"+variant_id+"']").innerHTML;
var selected_subprice = document.querySelector(".sell_plan_cs").value;
var get_price = document.querySelector(".sell_plan_cs option[value='"+selected_subprice+"']").getAttribute("data-price");
document.querySelector(".sub_pricing .final-price").innerHTML = symbol + get_price;
document.querySelector(".sub_pricing .plan-price").innerHTML = symbol + variant_price;
}

document.querySelector(".sell_plan_cs").addEventListener("change",function(){
var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
var variant_id = document.querySelector("[name='id']").value;
var variant_price = document.querySelector(".variant-sellings[data-id='"+variant_id+"']").getAttribute("data-price");
var selected_subprice = document.querySelector(".sell_plan_cs").value;
var get_price = document.querySelector(".sell_plan_cs option[value='"+selected_subprice+"']").getAttribute("data-price");
document.querySelector(".sub_pricing .final-price").innerHTML = symbol + get_price;
document.querySelector(".sub_pricing .plan-price").innerHTML = symbol + variant_price;
ChangePurchaseType();
ChangePurchaseTypePopup()

});

var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
var variant_id = document.querySelector("[name='id']").value;
var variant_price = document.querySelector(".variant-sellings[data-id='" + variant_id + "']").getAttribute("data-price");
document.querySelector(".one_time_pricing .price-onetime").innerHTML = symbol + variant_price;
document.querySelector(".sell_plan_cs").innerHTML = document.querySelector(".variant-sellings[data-id='"+variant_id+"']").innerHTML;
var selected_subprice = document.querySelector(".sell_plan_cs").value;
var get_price = document.querySelector(".sell_plan_cs option[value='"+selected_subprice+"']").getAttribute("data-price");
document.querySelector(".sub_pricing .final-price").innerHTML = symbol + get_price;
document.querySelector(".sub_pricing .plan-price").innerHTML = symbol + variant_price;
  
const inputOneTime = document.querySelector('#one_time_radio');
inputOneTime.addEventListener("change", (event) => {
let rcInputOneTime = "";
if(document.querySelector('.rc-template__radio-group input#rc-radio1') != null){  
  rcInputOneTime = document.querySelector('.rc-template__radio-group input#rc-radio1');
  rcInputOneTime.dispatchEvent(new Event('change', { bubbles: true }));
}

// customSelect.style.pointerEvents = 'none';
ChangePurchaseType();
ChangePurchaseTypePopup()
});

const inputSubTime = document.querySelector('#sub_radio');
inputSubTime.addEventListener("change", (event) => {
let rcInputSubTime = "";
if(document.querySelector('.rc-template__radio-group input#rc-radio2') != null){  
  rcInputSubTime = document.querySelector('.rc-template__radio-group input#rc-radio2');
  rcInputSubTime.dispatchEvent(new Event('change', { bubbles: true }));
}
// customSelect.style.pointerEvents = 'unset';
ChangePurchaseType();
ChangePurchaseTypePopup()
});

document.querySelectorAll("button[name='add']").forEach(function(get_btnname){
if(get_btnname != null){
get_btnname.setAttribute("data-product-id"," ");
get_btnname.addEventListener("click",function(){
var variant_id = document.querySelector("[name='id']").value;
var purchase_type = document.querySelector("input[name='purchase_type']:checked").value;
if(purchase_type == "sub"){
var selected_sellingplan = document.querySelector(".sell_plan_cs").value;
var jsonData = {
id:variant_id,
selling_plan:selected_sellingplan,
quantity:1
};
}
else{
var jsonData = {
id:variant_id,
quantity:1
};
}

fetch('/cart/add.js', {
method: 'POST', // or 'PUT'
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(jsonData)
})
.then(response => response.json())
.then(data => {
console.log('Success:', data);
})
.catch((error) => {
console.error('Error:', error);
});
});
}
});
function ChangePurchaseType(){
var selected_subprice = document.querySelector(".sell_plan_cs").value;
var purchase_type = document.querySelector("input[name='purchase_type']:checked").value;
document.querySelectorAll(".variant-sellings").forEach(function(selling_variant){
var variant_id = selling_variant.getAttribute("data-id");
var var_price = selling_variant.getAttribute("data-price");
var compare_price =  selling_variant.getAttribute("data-compare");
var var_title = selling_variant.getAttribute("data-title");
var closest_div = document.querySelector(".pf-option-swatches input[value='"+var_title+"']").closest("div");
var current_savespan = closest_div.querySelector("label .product-option-item__savings");
if(current_savespan != null){
current_savespan.remove();
}  

if(purchase_type == "sub"){
// var  selected_opt_price = selling_variant.querySelector("option[value='"+selected_subprice+"']").getAttribute("data-price");   
var  selected_opt_price = selling_variant.querySelector("option").getAttribute("data-price");   
var savings = parseFloat(var_price)-parseFloat(selected_opt_price);
var closest_div = document.querySelector(".pf-option-swatches input[value='"+var_title+"']").closest("div");
var current_label = closest_div.querySelector("label")
var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
var spanElement = document.createElement('span');
spanElement.textContent = 'Save '+symbol +savings.toFixed(2);
spanElement.classList.add("product-option-item__savings");
current_label.appendChild(spanElement);
}
else{
if(compare_price == ""){          
}
else{
// var savings = parseFloat(compare_price)-parseFloat(var_price);
// if(savings >= 1){      
// var closest_div = document.querySelector(".pf-option-swatches input[value='"+var_title+"']").closest("div");
// var current_label = closest_div.querySelector("label")
// var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
// var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
// var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
// var spanElement = document.createElement('span');
// spanElement.textContent = 'Save '+symbol +savings.toFixed(2);
// spanElement.classList.add("product-option-item__savings");
// current_label.appendChild(spanElement);
// }
}
}  
});
}
function ChangePurchaseTypePopup(){
var selected_subprice = document.querySelector(".sell_plan_cs").value;
var purchase_type = document.querySelector("input[name='purchase_type']:checked").value;
document.querySelectorAll(".variant-sellings").forEach(function(selling_variant){
var variant_id = selling_variant.getAttribute("data-id");
var var_price = selling_variant.getAttribute("data-price");
var compare_price =  selling_variant.getAttribute("data-compare");
var var_title = selling_variant.getAttribute("data-title");
var closest_div = document.querySelector("#popuptypeButton .pf-option-swatches input[value='"+var_title+"']").closest("div");
var current_savespan = closest_div.querySelector("label .product-option-item__savings");
if(current_savespan != null){
current_savespan.remove();
}  
if(purchase_type == "sub"){
// var  selected_opt_price = selling_variant.querySelector("option[value='"+selected_subprice+"']").getAttribute("data-price");   
var  selected_opt_price = selling_variant.querySelector("option").getAttribute("data-price");   
var savings = parseFloat(var_price)-parseFloat(selected_opt_price);
var closest_div = document.querySelector("#popuptypeButton .pf-option-swatches input[value='"+var_title+"']").closest("div");
var current_label = closest_div.querySelector("label")
var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
var spanElement = document.createElement('span');
spanElement.textContent = 'Save '+symbol +savings.toFixed(2);
spanElement.classList.add("product-option-item__savings");
current_label.appendChild(spanElement);
}
else{
if(compare_price == ""){
}
else{
// var savings = parseFloat(compare_price)-parseFloat(var_price);
// if(savings >= 1){
// var closest_div = document.querySelector("#popuptypeButton .pf-option-swatches input[value='"+var_title+"']").closest("div");
// var current_label = closest_div.querySelector("label")
// var get_currency = document.querySelector(".variant-sellings").getAttribute("data-currency");
// var currencyValue = get_currency.replace(/\{\{.*?\}\}/g, "");
// var symbol = currencyValue.replace(/<[^>]*>/g, '').trim().split(' ')[0];
// var spanElement = document.createElement('span');
// spanElement.textContent = 'Save '+symbol +savings.toFixed(2);
// spanElement.classList.add("product-option-item__savings");
// current_label.appendChild(spanElement);
// }
}
}
});
}
ChangePurchaseType();
ChangePurchaseTypePopup()
});